import { updateFoeBolt } from './foe-bolts';
import { updateSwipe } from './swipes';
import { updateParticle } from './particles';
import type { Engine } from './engine';

/** 敌方弹道寿命更新与回收。 */
export function updateFoeBolts(eng: Engine, dt: number): void {
  for (const b of eng.foeBoltPool.all()) {
    if (b.active && !updateFoeBolt(b, dt)) eng.foeBoltPool.release(b);
  }
}

/** 鞭横扫寿命更新与回收。 */
export function updateSwipes(eng: Engine, dt: number): void {
  for (const s of eng.swipePool.all()) {
    if (s.active && !updateSwipe(s, dt)) eng.swipePool.release(s);
  }
}

/** 粒子寿命更新与回收。 */
export function updateParticles(eng: Engine, dt: number): void {
  for (const p of eng.particlePool.all()) {
    if (!p.active) continue;
    updateParticle(p, dt);
    if (p.life <= 0) eng.particlePool.release(p);
  }
}
